import { makeStyles } from "@material-ui/core/styles";

const legendStyle = {
  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
  font: "12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif",
  padding: "10px",
  position: "absolute",
  right: "20px",
  top: "40px",
  background: "rgba(255, 255, 255, 0.7)",
  borderRadius: "3px",
};

const legendItemStyle = (bgColor) => ({
  backgroundColor: bgColor || "green",
  borderRadius: "50%",
  height: 10,
  width: 10,
  marginRight: 5,
  display: "inline-block",
});

const legendItemBoxStyle = (bgColor) => ({
  backgroundColor: bgColor || "green",
  height: 10,
  width: 10,
  marginRight: 5,
  display: "inline-block",
});

const useStyles = makeStyles(() => ({
  gradientBarContainer: {
    display: "flex",
    alignItems: "flex-start",
    paddingTop: 5,
  },

  gradientBar: (colors) => ({
    width: 20,
    height: 120,
    background: `linear-gradient(to bottom, ${[...colors]})`,
    marginRight: 10,
    position: "relative",
  }),

  labels: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: 120,
  },
}));

const LegendGradientItemStyle = ({ colors, labels }) => {
  const classes = useStyles(colors);

  return (
    <div className={classes.gradientBarContainer}>
      <div className={classes.gradientBar}></div>

      <div className={classes.labels}>
        {labels.map((label, index) => (
          <span key={index}>{label}</span>
        ))}
      </div>
    </div>
  );
};

export { legendStyle, legendItemStyle, LegendGradientItemStyle, legendItemBoxStyle };
